import { Injectable, OnDestroy } from '@angular/core';
import { CacheStoragesEnum } from '../../models/cache.models';

@Injectable()
export abstract class CacheStorageBase implements OnDestroy {
  protected isEnabledValue: boolean;
  protected isEnabledValueTimestamp: Date;
  protected readonly isEnabledValueTimeout: number = 10000;

  public abstract ngOnDestroy(): void;
  public abstract isEnabled(check?: boolean): boolean;
  public abstract getItem<TItem>(key: string, force?: boolean): TItem;
  public abstract setItem<TItem>(key: string, value: TItem): number | false;
  public abstract removeItem(key: string): void;

  public clear(prefix: string) {
    const keys: string[] = [];
    const length = this.length();
    for (let i = 0; i < length; i++) {
      const key = this.key(i);
      if (key.startsWith(prefix)) {
        keys.push(key);
      }
    }
    for (const key of keys) {
      this.removeItem(key);
    }
  }

  public abstract type(): CacheStoragesEnum;
  public abstract length(): number;
  public abstract key(index: number): string | null;

  public abstract persist(): void;
  public abstract unPersist(prefix: string): void;
}
